import React, { useContext, useEffect, useState } from "react";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetCartDTO from "../../../models/DTO/IOnGetCartDTO";
import ICart from "../../../models/ICart";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import styled from "styled-components";
import { Socket } from "socket.io-client";
import HelperService from "../../../services/HelperService";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    socket: Socket;
    proceedToCheckout: () => void;
};

export const EcommerceRightSideHeader: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const [cart, setCart] = useState<ICart>();

    useEffect(() => {
        props.socket.on(EndpointsEnum.CartOnGetCart, onGetCart);

        return () => {
            props.socket.removeListener(EndpointsEnum.CartOnGetCart, onGetCart);
        };
    }, []);

    const onGetCart = (data: IOnGetCartDTO) => {
        setCart(data.cart);
    };

    return (
        <EcommerceRightSideHeaderDiv>
            {cart?.Cart_Items?.length ? <OwButton title={"proceed_to_checkout"} fn={props.proceedToCheckout} /> : null}
            <div>
                <OwLabel title={"sub_total"} postText={":"} isBold={true} />{" "}
                {HelperService.formatCurrency({
                    value: cart?.sub_total || 0,
                    currency: "USD",
                    precision: supplierModel.pricing_precision || 2,
                })}
            </div>
        </EcommerceRightSideHeaderDiv>
    );
};

const EcommerceRightSideHeaderDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
`;
